/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const receiptsUploadStyle = {
  paper: {
    padding: "0.25rem 1rem 1rem",
  },
  inlineHintBox: {
    margin: "0 auto 40px auto",
    maxWidth: "700px",
    textAlign: "center",
    "& h4": {
      color: "primary.main",
      marginBottom: "20px",
    },
  },
  buttonContainer: {
    maxWidth: "350px",
    margin: "0 auto 40px auto",
  },
  divider: {
    borderBottom: "2px solid #ccc",
    margin: "1.5rem 0",
  },
  signatureCaption: {
    textAlign: "center",
  },
  headline: {
    textAlign: "center",
    fontWeight: "bold",
    color: "primary.main",
  },
};

export default receiptsUploadStyle;
